import React, { useContext } from 'react';
import { UserContext, UserOverrideContext, UserPermissionsOverrideContext, getUserFromConfig } from '@deephaven/auth-plugins';
import useServerConfig from "./useServerConfig.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * UserBootstrap component. Derives the UserContext from the ServerConfigContext, UserOverrideContext, and UserPermissionsOverrideContext.
 */
export function UserBootstrap(_ref) {
  var children = _ref.children;
  var serverConfig = useServerConfig();
  var overrides = useContext(UserOverrideContext);
  var permissionsOverrides = useContext(UserPermissionsOverrideContext);
  var user = getUserFromConfig(serverConfig, overrides, permissionsOverrides);
  return /*#__PURE__*/_jsx(UserContext.Provider, {
    value: user,
    children: children
  });
}
export default UserBootstrap;
//# sourceMappingURL=UserBootstrap.js.map